// extracted by mini-css-extract-plugin
export var alertIcon = "_ue-0";